module.exports = __webpack_public_path__ + "img/down_icon.9f96e680.svg";